module.exports = __webpack_public_path__ + "img/LDSJ_STILL21.73239609.jpg";